export default __webpack_public_path__ + "static/studyoffice-study3-f816cc7ff66e1463d8e380641d883ea6.jpg";